import { useEffect, useState } from "react";

import useRouterPush from "hooks/useRouterPush";

import { useGetBlogList } from "@/api/client/blog";
import { getBlogListData } from "@/api/server/blog";
import Loader from "@/components/data-display/loaderSvg";
import PageBanner from "@/components/data-display/pageBanner";
import { HeroFeedback } from "@/components/feedback";
import Pagination from "@/components/navigation/pagination";
import { BlogCategoryBar, BlogList } from "@/components/sections";
import MetaData from "@/components/seo/MetaData";
import { revalidationTime } from "@/utils/constants";
import statusCodes from "@/utils/constants/http-status-codes";
import { generateUrlToQuery } from "@/utils/helpers/queryString";

function Blogs({ data }) {
  const [blogList, setBlogList] = useState(data?.articles);
  const [categoryList, setCategoryList] = useState(data?.categories);
  const [meta, setMeta] = useState(data?.meta);

  const { queryParams, updateQueryParams } = useRouterPush();
  const { categories = "all" } = queryParams;

  useEffect(() => {
    setMeta(data?.meta);
    setBlogList(data?.articles);
    setCategoryList(data?.categories);
  }, [data]);

  const { isFetching: isBlogLoading } = useGetBlogList(
    generateUrlToQuery("", queryParams),
    {
      onSuccess: (data) => {
        setMeta(data?.meta);
        setBlogList(data?.articles);
        setCategoryList(data?.categories);
      },
      enabled: Object.keys(queryParams).length >= 1,
    }
  );

  const handleBlogFilter = (option) => {
    updateQueryParams({ categories: option, page: 1 });
  };

  return (
    <>
      <MetaData {...data?.metadata} schema={data?.schema} type="article" />

      {isBlogLoading && <Loader />}

      <PageBanner bannerText="Our Blog" />

      <BlogCategoryBar
        active={categories}
        data={categoryList}
        clickHandler={handleBlogFilter}
      />

      <div className="container">
        {blogList?.length > 0 ? (
          <div className="my-[3.5rem] space-y-[3.875rem] lg:my-[5rem] lg:space-y-[5.625rem]">
            <BlogList blogs={blogList} />

            {meta?.total > meta?.per_page && (
              <Pagination
                initialPage={meta?.current_page - 1}
                getPaginateData={(page) =>
                  updateQueryParams({ page: page + 1 })
                }
                totalPage={Math.ceil(meta.total / meta.per_page)}
              />
            )}
          </div>
        ) : (
          <div className="py-5">
            <HeroFeedback
              title="No blog found!"
              imageAltText="blog-not-found"
              imageURL="/assets/images/no-upcoming.png"
            />
          </div>
        )}
      </div>
    </>
  );
}

export const getStaticProps = async () => {
  const props = { data: null };

  const res = await getBlogListData();
  if (res?.status === statusCodes.OK) props.data = res?.data?.data;

  return {
    props,
    revalidate: revalidationTime,
  };
};

export default Blogs;
